import { render, staticRenderFns } from "./WIconSelect.vue?vue&type=template&id=7cae0962"
import script from "./WIconSelect.vue?vue&type=script&lang=js"
export * from "./WIconSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports